const BankingPayments = ({ methods, minDeposit,name }) => {
  const renderMethodCard = (method, i) => (
    <div
      key={i}
      className="flex items-center border border-gray-300 dark:border-gray-600 rounded-xl px-6 py-5 bg-white dark:bg-[#1e2430] transition-all duration-300"
    >
      {/* ✅ Logo Box */}
      <div className="flex items-center justify-center bg-white dark:bg-[#1e2430] border border-gray-300 dark:border-gray-600 rounded-md w-20 h-14 shrink-0">
        <img
          src={method?.image}
          alt={`${method?.name}`}
          className="w-[65%] h-[65%] object-contain"
        />
      </div>

      {/* ✅ Text Section */}
      <div className="ml-3 flex flex-col justify-center text-left">
        <p className="font-semibold text-gray-800 dark:text-gray-100 text-[15px]">
          {method.name}
        </p>
        <p className="text-gray-600 dark:text-gray-400 text-[14px] mt-[1px]">
          Instant
        </p>
      </div>
    </div>
  );

  return (
    <section className="mt-12 max-w-[1440px] mx-auto px-5 sm:px-8 md:px-12 lg:px-16 xl:px-20 pb-12 transition-colors duration-300">
      {/* ✅ Header */}
      <div className="mb-6 text-left">
        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
          Banking & Payments
        </h2>
        <hr className="border-t-[1px] border-gray-400 dark:border-gray-600 mb-3" />
        <p className="text-gray-700 dark:text-gray-300">
          Secure and convenient payment options available at {name}.
        </p>
      </div>

      {/* ✅ Deposit Section (Full Width) */}
      <div className="border border-gray-300 dark:border-gray-600 rounded-2xl bg-white dark:bg-[#1e2430] p-8 transition-colors duration-300">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-6 text-left">
          Deposit Methods
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {methods.map(renderMethodCard)}
        </div>

        <div className="flex justify-between text-sm text-gray-700 dark:text-gray-400 mt-6">
          <span>Min Deposit: {minDeposit}</span>
          {/* <span>Max Deposit: €2,500/day</span> */}
        </div>
      </div>
    </section>
  );
};

export default BankingPayments;
